import React, {useState, useCallback } from 'react';
import './footer.scss';
import {Link} from "react-router-dom";
import logo from "../../images/logo.png";
import useInput from "../../hook/useInput";

const Footer = ({menuNav}) => {
    const [menuState, setMenuState] = useState('home');

    const [subscribeEmail, onSubscribeEmailChange] = useInput('');
    const onMove = useCallback((to) => {
        setMenuState(to);
        menuNav(to);
    }, [setMenuState]);
    return (
        <footer className="App-footer">
            <div className="footer-row">
                <div className="f-social-row">
                    <div className="social-col">
                        <a href="#" className="social-link-f">
                            <i className="icon-fb15x"/>
                        </a>
                        <a href="#" className="social-link-f">
                            <i className="icon-insta15x"/>
                        </a>
                        <a href="#" className="social-link-f">
                            <i className="icon-insta-115x"/>
                        </a>
                        <a href="#" className="social-link-f">
                            <i className="icon-youtube15x"/>
                        </a>
                    </div>
                    <div className="app-link-col">
                        <div className="app-download-b">
                            <div className="ico-col-v">
                                <i className="icon-apple15x"/>
                            </div>
                            <p className="text-col-v">
                                <i className="s-title-v">Download on the</i>
                                <span className="store-name-v">App Store</span>
                            </p>
                        </div>
                        <div className="app-download-b">
                            <div className="ico-col-v">
                                <i className="icon-android15x"/>
                            </div>
                            <p className="text-col-v">
                                <i className="s-title-v">Get it on</i>
                                <span className="store-name-v">Google Play</span>
                            </p>
                        </div>
                        <div className="btn-v middle disabled">Coming Soon</div>
                    </div>
                </div>
                <div className="f-nav-row">
                    <div className="f-nav-col">
                        <div className="f-nav-item">
                            <a href="#" className="f-link-v">About us</a>
                        </div>
                        <div className="f-nav-item">
                            <a href="/terms" className="f-link-v">Terms of Service</a>
                        </div>
                        <div className="f-nav-item">
                            <a href="/privacy-policy" className="f-link-v">Privacy Policy</a>
                        </div>
                    </div>
                    <div className="subscribe-col">
                        <input className="input-v medium" type="Email" placeholder="Email" onChange={onSubscribeEmailChange}/>
                        <button className="btn-v middle trans" onClick={() => console.log(subscribeEmail)}>Subscribe</button>
                    </div>
                </div>
                <div className="copyright-r">
                    <p className="copyright-text">Copyright © 2020 ClubDaddy. All Rights Reserved.</p>
                    <Link to="/" className="logo">
                        <img src={logo} alt=""/>
                    </Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;

